<script>
    import { _ } from 'svelte-i18n';
    import Header from './Header.svelte';
	import { isLoading } from 'svelte-i18n';
	import Welcome from './Welcome.svelte';
    import Calculator from './calculator/Calculator.svelte';
    import MuscleSelection from './calculator/MuscleSelection.svelte';
    import ValueForm from './calculator/ValueForm.svelte';
    import Results from './calculator/Results.svelte';
	import InfoSection from './learn/InfoSection.svelte';
	import LinkSection from './learn/LinkSection.svelte';
	import { Router, Route } from 'svelte-routing';
	import InfoPage1 from './pages/InfoPage1.svelte';
	import InfoPage2 from './pages/InfoPage2.svelte';
	import InfoPage3 from './pages/InfoPage3.svelte';
	import NotFound from './pages/NotFound.svelte';
	import smoothscroll from 'smoothscroll-polyfill'
	import Footer from './Footer.svelte';

	export let url = "";

	/* Polyfill to make smooth scroll work on Safari */
	smoothscroll.polyfill();

	let hidden = true;

	let info_active = () => {
		hidden = !hidden;
	}

	const scrollToId = (id) => document.getElementById(id).scrollIntoView({behavior: "smooth"});

	function isIE() {
  		const ua = navigator.userAgent;
  		/* MSIE used to detect old browsers and Trident used to newer ones */
        const is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

  		return is_ie;
	}

	/* Create an alert to show if the browser is IE */
	if (isIE()){
    	alert($_('isIE'));
		/* Unfortunately it isn't clear if this is ever shown. IE does not seem to get even this far in the loading of Svelte. */
	}

</script>

<style>
	main {
		position: relative;
	}

	.overlay {
		position: absolute;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.5);
		z-index: 10;
	}

	.overlay.hidden {
		display: none;
	}

	.loading {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100%;
	}

	.loading img {
		width: 40px;
		height: 40px;
	}

	.loading span {
		font-size: var(--typeSizeMedium);
		margin-top: var(--spacingLarge);
	}

</style>

<Router {url} >
	{#if $isLoading}
		<div class="loading">
			<img alt="loading symbol" src="/img/preloader.gif">
		<span>{$_('loading')} {$_('header.title')}...</span>
		</div>
		{:else}
		<main>
			<div class:hidden class="overlay" on:click={info_active}></div>
			<Header />
            
			<Route path="/">
				<Welcome {scrollToId} />
				<Calculator step={1} {hidden} {info_active} component={MuscleSelection} />
				<InfoSection />
            	<LinkSection />
            	<Footer />
			</Route>
			<Route path="/calculator-1">
				<Welcome {scrollToId} />
				<Calculator step={2} {hidden} {info_active} component={ValueForm} />
				<InfoSection />
            	<LinkSection />
            	<Footer />
            </Route>
			<Route path="/calculator-2">
				<Welcome {scrollToId} />
				<Calculator step={3} {hidden} {info_active} component={Results} />
				<InfoSection />
            	<LinkSection />
            	<Footer />
			</Route>
			
			<Route path="/muskelstyrka-matning" component={InfoPage1} />
			<Route path="/tabell-utgangsstallningar" component={InfoPage2} />
			<Route path="/filmer-matning" component={InfoPage3} />
			<Route path="/*" component={NotFound} />

        </main>
	{/if}
</Router>

<svelte:head>
    <title>{$_('header.title')}</title>
</svelte:head>
